module.exports = require("./../../_gen/starling/rendering/VertexDataFormat");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/rendering/VertexDataFormat.js
// module id = 220
// module chunks = 0